import Balance from '../components/PaymentApplication/Balance'
import Withdrawal from '../components/PaymentApplication/Withdrawal'
import Complete from '../components/PaymentApplication/Complete'

export default [
  {
    path: '/client/payment/balance',
    name: 'balance',
    component: Balance,
    meta: {
      sideMenuId: 'payment',
    },
  },
  {
    path: '/client/payment/withdrawal',
    name: 'withdrawal',
    component: Withdrawal,
    meta: {
      sideMenuId: 'payment',
    },
  },
  {
    path: '/client/payment/complete',
    name: 'payment-complete',
    component: Complete,
    meta: {
      sideMenuId: 'payment',
    },
  },
]
